import { useEvent } from "../../../context/EventContext";

// A component to display the speaker details of the selected event.
//  * This component gets the selectedEvent from the EventContext and displays the speaker details of the event.
//  If the selectedEvent is not present or does not have any speaker details, it displays a message saying that no speaker details are found.
const Speakers = () => {
  const { selectedEvent } = useEvent();

  const speakerDetailsArray =
    selectedEvent && selectedEvent[2] ? selectedEvent[2] : [];

  return (
    <div className="speaker-section-details">
      {speakerDetailsArray.length === 0 && (
        <h1 style={{ paddingLeft: "300px" }}>No Speaker Details found.</h1>
      )}
      {speakerDetailsArray.map((speakerDetails, index) => (
        <div key={index} className="speaker-card">
          <img src={speakerDetails?.image_url} alt="Speaker" />
          <p>{speakerDetails?.speaker_name}</p>
          <p>{speakerDetails?.company_name}</p>
          <p>
            Follow on : <span>Twitter</span>
          </p>
        </div>
      ))}
    </div>
  );
};

export default Speakers;
